import { EmojiRender, withErrorBoundary } from '@nile/components';
import React, { useEffect, useState } from 'react';
import Picker from 'emoji-picker-react';
import Tippy from '@tippyjs/react';
import { cloneDeep, isEmpty } from 'lodash';

const DEFAULT_EMOJI = {
  activeSkinTone: 'neutral',
  emoji: '😀',
  imageUrl:
    'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f600.png',
  isCustom: false,
  names: ['grinning', 'grinning face'],
  unified: '1f600',
  unifiedWithoutSkinTone: '1f600'
};

const EmojiPicker = (props) => {
  const { allowMultiple, onChange, size = 'md', emoji, type = 'emoji' } = props;

  const defaultEmoji = !isEmpty(emoji)
    ? emoji
    : type === 'unicode'
    ? [DEFAULT_EMOJI?.unicode]
    : [DEFAULT_EMOJI?.emoji];

  const [active, setActive] = useState(false);
  const [emojiData, setEmojiData] = useState(defaultEmoji);
  const tippyRef = React.useRef(null);

  useEffect(() => {
    if (emojiData && !props?.emoji) {
      onChange(emojiData);
    }
  }, []);

  const toggleEmojiPicker = () => {
    setActive((state) => !state);
  };

  const onEmojiChange = (emojiObject, event) => {
    if (allowMultiple) {
      const data = !isEmpty(emojiData) ? cloneDeep(emojiData) : [];
      if (type === 'unicode') {
        data.push(emojiObject?.unicode);
      } else {
        data.push(emojiObject?.emoji);
      }
      setEmojiData([...data]);
      onChange(data, event);
    } else {
      const data =
        type === 'unicode' ? [emojiObject?.unicode] : [emojiObject?.emoji];
      setEmojiData([...data]);
      toggleEmojiPicker();
      onChange(data, event);
    }
  };

  const classNames = ['flex actr fhp', size].filter(Boolean).join(' ');

  return (
    <Tippy
      content={
        <>
          {active && (
            <Picker
              onEmojiClick={onEmojiChange}
              emojiStyle="native"
              previewConfig={{ showPreview: false }}
            />
          )}
        </>
      }
      duration={250}
      delay={500}
      interactive
      placement="bottom-start"
      allowHTML
      theme="light"
      trigger="manual"
      zIndex={600}
      visible={active}
      ref={(node) => {
        tippyRef.current = node;
      }}
    >
      <div
        id="superops-emoji-picker"
        className="pointer"
        onClick={toggleEmojiPicker}
      >
        <div className={`${size || ''}`}>
          {emojiData.map((emoji) => {
            return (
              <EmojiRender
                emoji={emoji}
                className="flex actr fhp"
                size={size}
              />
            );
          })}
        </div>
      </div>
    </Tippy>
  );
};

export default withErrorBoundary(EmojiPicker);
